// extracted by mini-css-extract-plugin
module.exports = {"maxSiteWidth":"75rem","mainContent":"wEpKM9TG_tAncl3MEiICD"};